// src/pages/Workflows/Editor/components/NodePalette.js
// Coluna esquerda do Editor: catálogo de nós disponíveis

import React from 'react';
import { NODE_DEFINITIONS, CATEGORIAS_ORDEM, CATEGORIA_LABELS, CATEGORIA_CORES } from '../utils/nodeDefinitions';

export default function NodePalette({ onAddNode }) {
  // Agrupar nós por categoria
  const grupos = CATEGORIAS_ORDEM.reduce((acc, cat) => {
    const nos = Object.entries(NODE_DEFINITIONS).filter(([, def]) => def.categoria === cat);
    if (nos.length > 0) acc[cat] = nos;
    return acc;
  }, {});

  const handleClick = (tipo, enabled) => {
    if (!enabled) return;
    // Sem posição: o canvas coloca o nó abaixo dos existentes (o utilizador
    // pode arrastar depois). Para posicionar ao pixel, arrastar da paleta.
    onAddNode(tipo);
  };

  const handleDragStart = (e, tipo) => {
    e.dataTransfer.setData('application/workflow-node-type', tipo);
    e.dataTransfer.effectAllowed = 'copy';
  };

  return (
    <div className="wf-palette">
      <div className="wf-palette-title">Nós</div>
      {Object.entries(grupos).map(([cat, nos]) => (
        <div key={cat} className="wf-palette-group">
          <div
            className="wf-palette-cat-label"
            style={{ color: CATEGORIA_CORES[cat] }}
          >
            {CATEGORIA_LABELS[cat] || cat}
          </div>
          {nos.map(([tipo, def]) => (
            <div
              key={tipo}
              className={`wf-palette-item${def.enabled ? '' : ' wf-palette-item--disabled'}`}
              draggable={def.enabled}
              onDragStart={def.enabled ? (e) => handleDragStart(e, tipo) : undefined}
              onClick={() => handleClick(tipo, def.enabled)}
              title={def.enabled ? def.descricao : 'Em breve'}
              style={{ borderColor: CATEGORIA_CORES[def.categoria] }}
            >
              <span
                className="wf-palette-item-dot"
                style={{ background: CATEGORIA_CORES[def.categoria] }}
              />
              <span className="wf-palette-item-label">{def.label}</span>
              {!def.enabled && (
                <span className="wf-palette-item-soon">Em breve</span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
